var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_c('ContextMenu',{staticClass:"d-sm-none float-right",attrs:{"id":"training-mobile-menu","items":_vm.menu,"align":"right"}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('TabMenu',{staticClass:"d-none d-sm-block pt-2",attrs:{"tabs":_vm.menu,"current":_vm.current}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }